import { render, staticRenderFns } from "./queryRestockList.vue?vue&type=template&id=85fc5aac"
import script from "./queryRestockList.vue?vue&type=script&lang=js"
export * from "./queryRestockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports